import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { SubSink } from 'subsink';
import { environment } from '../../../../environments/environment';
import { GlobalConstants } from '../../constants/globals';
import { AuthGuardService } from '../../guards/auth-guard.service';
import { CustomValidators } from '../../handlers/custom-validators';
import { AuthServiceResponse } from '../../models/auth-service-response.model';
import { ApiRequestService } from '../../services/api-request.service';
import { AuthService } from '../../services/auth.service';
import { LoggedInUserService } from '../../services/logged-in-user.service';
import { TranslateService } from '../../translate';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnDestroy {
    @Input()
    emailData: string;
    domain: any;
    deviceInfo = null;
    errorMessage = '';
    errorFlagServiceFailure = false;
    userEmail;
    passFiledType = 'password';
    passwordEyeFlag: any = '0';
    @ViewChild('password') passwordField: ElementRef;
    @Output() loggedIn = new EventEmitter<boolean>();
    @ViewChild(NgbDropdown) private domainsListMenu: NgbDropdown;
    domainList: any = [
        {
            domainName: GlobalConstants.DOMAIN_STC,
            domainValue: GlobalConstants.DOMAIN_STC_VALUE
        }
    ];
    newRequestForm: FormGroup;
    emailFormControl = 'emailFormControl';
    passwordFormControl = 'passwordFormControl';

    formInputList = [
        {
            controlName: this.emailFormControl,
            validators: [Validators.required, CustomValidators.noWhitespaceValidator, CustomValidators.emailValidator]
        },
        {
            controlName: this.passwordFormControl,
            validators: [Validators.required, CustomValidators.noWhitespaceValidator]
        }
    ];
    subs = new SubSink();

    constructor(
        private cookies: CookieService,
        private apiRequestService: ApiRequestService,
        private loggedInUserService: LoggedInUserService,
        private translateService: TranslateService,
        private authGuard: AuthGuardService,
        private authService: AuthService
    ) {
        this.initForm();
    }

    private initForm() {
        this.newRequestForm = new FormGroup({});
        this.formInputList.forEach(element => {
            const control: FormControl = new FormControl('', element.validators);
            this.newRequestForm.addControl(element.controlName, control);
        });
    }

    showDomains(e: any) {
        if (e.target.value.slice(-1) === '@') {
            this.openDropdown();
        }
    }

    openDropdown() {
        this.domainsListMenu.open();
    }

    closeDropdown() {
        this.domainsListMenu.close();
    }

    getDomainName(e: any) {
        this.domain = e.target.getAttribute('emailData');
        this.userEmail = this.userEmail + this.domain;
        this.closeDropdown();
        this.passwordField.nativeElement.focus();
    }

    closeError() {
        this.errorMessage = '';
        this.errorFlagServiceFailure = false;
    }

    login(username: string, password: string) {
        const formValid = this.newRequestForm.status === 'VALID';

        if (formValid) {
            this.closeError();
            const loggingUser = {
                email: username.trim(),
                password: password
            };

            this.subs.sink = this.apiRequestService.dummyLogin(loggingUser).subscribe(
                (response: any) => {
                    this.hideLogin(response.data);
                    this.loggedInUserService.storeLoggedInUserDetails(response.data.user);
                },
                error => {
                    this.errorFlagServiceFailure = true;
                    this.errorMessage = 'failedLoginMSg';
                }
            );
        }
    }

    hideLogin(loginResponse: AuthServiceResponse) {
        this.authService.storeUserAuthenticationStatus(true);
        this.cookies.delete('email', '/');
        this.cookies.set('email', loginResponse.user.email, null, '/');
        this.cookies.set('userId', JSON.stringify(loginResponse.user.id), null, '/');
        this.cookies.set('token', loginResponse.accessToken, null, '/');
        const userRole = this.loggedInUserService.getHighestRoleLevel(loginResponse.user);
        this.cookies.set('userRole', userRole, null, '/');
        window.location.href = environment.prefix + '/';
        this.loggedIn.emit(true);
    }

    changPassType() {
        this.passFiledType = this.passwordEyeFlag === '0' ? 'text' : 'password';
        this.passwordEyeFlag = this.passwordEyeFlag === '0' ? '1' : '0';
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
